import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  HeadObj: {
    DocType: "",
    DocName: "",
    DocNo: "",
    Date: new Date(),
    Loc: "",
    LocName: "",
    UnloadingBin: "",
    Auto: "A", //A-true M-false
    UnloadingBinName: "",
    A_DocStat: "ENTER",
  },
};

const SlicePutAway = createSlice({
  name: "SlicePutAway",
  initialState: { value: initialState },

  reducers: {
    Set_SlicePutAway_HeadObj: (state, action) => {
      state.value.HeadObj = action.payload;
    },
    Set_SlicePutAway_HeadObj_Init: (state, action) => {
      state.value.HeadObj = initialState.HeadObj;
    },
    SlicePutAway_Init: (state) => {
      state.value = initialState;
    },
    Set_SlicePutAway_HeadObj_New_Set: (state, action) => {
      state.value.HeadObj.Date = action.payload.Date;
    },
    Set_SlicePutAway_HeadObject_A_DocStat: (state, action) => {
      state.value.HeadObj.A_DocStat = action.payload.A_DocStat;
    },
  },
});

export const {
  Set_SlicePutAway_HeadObj,
  Set_SlicePutAway_HeadObject_A_DocStat,
  SlicePutAway_Init,
  Set_SlicePutAway_HeadObj_Init,
  Set_SlicePutAway_HeadObj_New_Set,
} = SlicePutAway.actions;
export default SlicePutAway.reducer;
